import React, { useState, useEffect } from "react";
import Popup from "../Popup/Popup";
import InputComponent from "../../components/DynamicInput/DynamicInput";
import useEventsQueries from "../../../store/events/eventsQueries";
import loaderGif from "../../../assets/gifs/loader.gif";
import "./EventDetailsPopup.css";

const EventDetailsPopup = ({ event, isVisible, onClose }) => {
  const { handleGetPocDetailsGateway } = useEventsQueries();
  const [isLoadingPoc, setIsLoadingPoc] = useState(false);
  const [pocDetails, setPocDetails] = useState({
    srManager: "N/A",
    manager: "N/A",
    rep: "N/A",
  });

  useEffect(() => {
    const fetchPocDetails = async () => {
      if (!event?.poc_array || event.poc_array.length < 3) {
        setPocDetails({ srManager: "N/A", manager: "N/A", rep: "N/A" });
        return;
      }

      const [srManagerCrnId, managerCrnId, repCrnId] = event.poc_array;
      setIsLoadingPoc(true);

      try {
        const pocPromises = [
          srManagerCrnId
            ? handleGetPocDetailsGateway(srManagerCrnId)
            : Promise.resolve(null),
          managerCrnId
            ? handleGetPocDetailsGateway(managerCrnId)
            : Promise.resolve(null),
          repCrnId
            ? handleGetPocDetailsGateway(repCrnId)
            : Promise.resolve(null),
        ];

        const results = await Promise.allSettled(pocPromises);
        const details = { srManager: "N/A", manager: "N/A", rep: "N/A" };

        const roles = ["srManager", "manager", "rep"];
        results.forEach((result, index) => {
          if (result.status === "fulfilled" && result.value?.agents?.[0]) {
            const agent = result.value.agents[0];
            const fullNameCrn = `${agent.first_name} ${agent.last_name} - (${agent.crn_id})`;
            details[roles[index]] = fullNameCrn;
          }
        });

        setPocDetails(details);
      } catch (error) {
        console.error("Failed to fetch POC details:", error);
        setPocDetails({ srManager: "N/A", manager: "N/A", rep: "N/A" });
      } finally {
        setIsLoadingPoc(false);
      }
    };

    fetchPocDetails();
  }, [event]);

  if (!event) return null;

  const startDate = new Date(event.start_date_time).toISOString().split("T")[0];
  const endDate = new Date(event.end_date_time).toISOString().split("T")[0];
  const startTime = new Date(event.start_date_time).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const endTime = new Date(event.end_date_time).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const formFields = [
    {
      label: "School Name",
      type: "text",
      value: event.school_name || "N/A",
      config: {
        label: "School Name",
        type: "text",
        placeholder: "Search school",
        required: true,
      },
    },
    // {
    //   label: "Event Type",
    //   type: "select",
    //   value: event.event_type || "",
    //   config: {
    //     label: "Event Type",
    //     type: "select",
    //     placeholder: "Select Event Type",
    //     required: true,
    //     options: [
    //       { label: "Academic", value: "ACADEMIC" },
    //       { label: "Extra Curricular", value: "EXTRA_CURRICULAR" },
    //     ],
    //   },
    // },
    {
      label: "Event Name",
      type: "select",
      value: event.name || "",
      config: {
        label: "Event Name",
        type: "select",
        placeholder: "Select Event",
        required: true,
        options: [{ label: event.name, value: event.name }],
      },
    },
    {
      label: "Event Level",
      type: "select",
      value: event.level || "",
      config: {
        label: "Event Level",
        type: "select",
        placeholder: "Select Level",
        required: true,
        options: [{ label: event.level, value: event.level }],
      },
    },
    {
      label: "Round",
      type: "select",
      value: event.round || "",
      config: {
        label: "Round",
        type: "select",
        placeholder: "Select Round",
        required: true,
        options: [{ label: event.round, value: event.round }],
      },
    },
    {
      label: "Grade",
      type: "select",
      value: event.grade || "",
      config: {
        label: "Grade",
        type: "select",
        placeholder: "Select Grade",
        required: true,
        options: [{ label: event.grade, value: event.grade }],
      },
    },
    {
      label: "Start Date",
      type: "date",
      value: startDate,
      config: { label: "Start Date", type: "date", required: true },
    },
    {
      label: "End Date",
      type: "date",
      value: endDate,
      config: { label: "End Date", type: "date", required: true },
    },
    {
      label: "Start Time",
      type: "time",
      value: startTime,
      config: { label: "Start Time", type: "time", required: true },
    },
    {
      label: "End Time",
      type: "time",
      value: endTime,
      config: { label: "End Time", type: "time", required: true },
    },
    {
      label: "Description",
      type: "textarea",
      value: event.description || "No description available",
      config: {
        label: "Description (optional)",
        type: "textarea",
        placeholder: "Description",
        required: false,
      },
    },
  ];
  const teamsFiels = [
    {
      label: "Senior Manager",
      type: "text",
      value: pocDetails.srManager,
      config: {
        label: "Senior Manager",
        type: "text",
        placeholder: "Senior Manager",
        required: true,
      },
    },
    {
      label: "Manager",
      type: "text",
      value: pocDetails.manager,
      config: {
        label: " Manager",
        type: "text",
        placeholder: "Manager",
        required: true,
      },
    },
    {
      label: "EExecution Rep",
      type: "text",
      value: pocDetails.rep,
      config: {
        label: "Execution Rep",
        type: "text",
        placeholder: "Execution Rep",
        required: true,
      },
    },
  ];
  return (
    <Popup
      isVisible={isVisible}
      onClose={onClose}
      title="Event Details"
      FirstBtnTitle="Close"
      SecondBtnTitle="OK"
      handelSecondry={onClose}
      handelPrimery={onClose}
      contentClassName="event-details-popup__content"
    >
      <div className="event-details-popup__body">
        {formFields.map((field, index) => (
          <InputComponent
            key={index}
            config={field.config}
            value={field.value}
            onChange={() => {}}
            disabled={true}
            options={{}}
          />
        ))}

        <div className="event-details-popup__section">
          <div className="event-details-popup__section-inner">
            <h4>Administrative control</h4>
            <div className="event-details-popup__row event-details-popup__row--toggle">
              <p className="input-text-label event-details-popup__toggle-label">
                Is Paid Report?
              </p>
              <InputComponent
                config={{ type: "toggle" }}
                value={event.is_paid_report}
                onChange={() => {}}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="event-details-popup__section">
          <div className="event-details-popup__section-inner">
            <h4>Assign Team</h4>
            <div className="event-details-popup__row event-details-popup__row--team">
              {isLoadingPoc ? (
                <div className="event-details-popup__loader">
                  <img
                    src={loaderGif}
                    alt="Loading..."
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>
              ) : (
                teamsFiels.map((field, index) => (
                  <InputComponent
                    key={index}
                    config={field.config}
                    value={field.value}
                    onChange={() => {}}
                    disabled={true}
                    options={{}}
                  />
                ))
              )}
            </div>
          </div>
        </div>
        <div className="event-details-popup__section">
          <div className="event-details-popup__section-inner">
            <h4>Event Mode</h4>
            <div className="event-details-popup__row event-details-popup__row--mode">
              <div className="event-details-popup__radio">
                <input
                  type="radio"
                  id="offline"
                  name="eventtype"
                  value="OFFLINE"
                  checked={event.event_type === "OFFLINE"}
                  onChange={() => {}}
                  disabled
                />
                <label htmlFor="offline">Offline</label>
              </div>
              <div className="event-details-popup__radio">
                <input
                  type="radio"
                  id="online"
                  name="eventtype"
                  value="ONLINE"
                  checked={event.event_type === "ONLINE"}
                  onChange={() => {}}
                  disabled
                />
                <label htmlFor="online">Online</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default EventDetailsPopup;
